import React, { Component } from 'react';
import { Menu } from 'antd';
import { Route, Switch, Redirect } from 'react-router-dom';
import OrderList from '../order/list';
import OrderDetail from '../order/detail';
import PortQualityReport from '../order/portQualityReport';
import WarehouseQualityReport from '../order/warehouseQualityReport';
import CustomerQualityReport from '../order/component/customer/Detail';
import OrderInformation from '../order/orderInformation';
import PlanOrderList from '../planOrder/planOrderList';
import PlanOrderDetail from '../planOrder/planOrderDetail';
import EnquiryOrderList from '../enquiry/list';
import EnquiryOrderDetail from '../enquiry/detail';
import AddressList from '../address/addressList';
import ErpList from '../erpList/index';
import Bill from '../bill/index/index';
import BillDetail from '../bill/detail';
import Print from '../bill/print';
import AnnualPlanOrderList from '../AnnualPlanOrder/annualPlanOrderList';
import AnnualPlanOrderDetail from '../AnnualPlanOrder/annualPlanOrderDetail';
import PlanList from '../planReport/planList';
import PlanReportDetail from '../planReport/planReportDetail';
import ReportedList from '../planReport/reportedList';
import SelectProducts from '../planReport/selectProducts';
import PrePlanList from '../prePlanReport/planList';
import PrePlanReportDetail from '../prePlanReport/planReportDetail';
import PreReportedList from '../prePlanReport/reportedList';
import PreSelectProducts from '../prePlanReport/selectProducts';
import Proposal from '../proposal';
import ProposalList from '../proposal/list';
import ProposalPurchasingList from '../proposal/purchasingList';
import PurchasingDetail from '../proposal/purchasingDetail';
import OrderSettings from '../proposal/Settings';
import returnOrder from '../returnOrder/list';
import ProposalCart from '../proposal/cart';
import QualityGradient from '../quality/qualityGradient/index';
import QualityGradientDetail from '../quality/qualityGradient/detail';
import QualityStandard from '../quality/qualityStandard/index';
import QualityStandardDetail from '../quality/qualityStandard/detail';
import QualityTask from '../quality/qualityTask';
import QualityTaskDetail from '../quality/qualityTask/detail';
import ProposalDetail from '../proposal/detail';
import CpLogo from '../../components/CpLogo';
import { keyToValue } from '../../util/tool';
import './style.less';

const userItems = [
  { label: '我的采购单', key: 'order', },
  { label: '我的计划单', key: 'planOrder', },
  { label: '我的询价单', key: 'enquiryOrder', },
  { label: '年度计划管理', key: 'annualPlanOrder', },
  { label: '统采计划提报', key: 'planReport', },
  { label: '收货地址', key: 'address', },
  { label: '我的对账单', key: 'bill', },
  { label: 'ERP供应商清单', key: 'erpList', },
  { label: '预售订单', key: 'prePlanReport', },
  { label: '采购建议', key: 'proposal', },
  { label: '订货清单', key: 'proposalCart', },
  { label: '我的订货单', key: 'proposalList', },
  // { label: '常购清单', key: 'proposalCartPurchasingList', },
  { label: '订货设置', key: 'OrderSettings', },
  { label: '门店退货单', key: 'returnOrder', },
  { label: '抽检梯度', key: 'qualityGradient', },
  { label: '质检标准', key: 'qualityStandard', },
  { label: '质检记录', key: 'qualityTask', },
];

const PathMapKeys = {
  order: '/basic/user/order',
  planOrder: '/basic/user/planOrder',
  enquiryOrder: '/basic/user/enquiryOrder',
  address: '/basic/user/address',
  erpList: '/basic/user/erpList',
  bill: '/basic/user/bill',
  annualPlanOrder: '/basic/user/annualPlanOrder',
  planReport: '/basic/user/planReport',
  prePlanReport: '/basic/user/prePlanReport',
  proposal: '/basic/user/proposal',
  proposalList: '/basic/user/proposalList',
  // proposalCartPurchasingList: '/basic/user/proposalCart/purchasingList',
  proposalCart: '/basic/user/proposalCart',
  // proposalCart: '/basic/proposalCart',
  OrderSettings: '/basic/user/orderSettings',
  returnOrder: '/basic/user/returnOrder',
  qualityGradient: '/basic/user/qualityGradient',
  qualityStandard: '/basic/user/qualityStandard',
  qualityTask: '/basic/user/qualityTask',
};

const PATH2KEY = keyToValue(PathMapKeys);

class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMenuKey: '',
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    let { pathname } = this.props.location;

    if (pathname === '/basic/user') {
      pathname = PathMapKeys['order'];
    } else {
      let pathNameArray = pathname.split('/');
      if (pathNameArray.length >= 4) {
        pathNameArray = pathNameArray.splice(0, 4);
        pathname = pathNameArray.join('/');
      }
    }
    this._isMounted && this.setState({
      activeMenuKey: PATH2KEY[pathname]
    });
  }

  shouldComponentUpdate(nextProps) {
    let prevRouteName = this.props.location.pathname;
    let currentRouteName = nextProps.location.pathname;
    if (prevRouteName !== currentRouteName) {
      let { pathname } = nextProps.location;
      if (pathname === '/basic/user') {
        pathname = PathMapKeys['order'];
      } else {
        let pathNameArray = pathname.split('/');
        if (pathNameArray.length >= 4) {
          pathNameArray = pathNameArray.splice(0, 4);
          pathname = pathNameArray.join('/');
        }
      }
      if (this._isMounted) {
        this.setState({ activeMenuKey: PATH2KEY[pathname] }, () => {
          this._isMounted && window.scrollTo(0, 0);
        });
      }
    }
    return true;
  }

  onClickMenu = (e) => {
    const { key } = e;
    const { history } = this.props;
    this._isMounted && this.setState({ activeMenuKey: key, }, () => {
      this._isMounted && history.push(PathMapKeys[key]);
    });
  };

  componentWillUnmount() {
    this._isMounted = false;
    this.setState = () => {};
  }

  render() {
    const { activeMenuKey } = this.state;
    return (
      <div className="user">
        <div className="user-left">
          <div className="left-top"><CpLogo /></div>
          <Menu className="menu" onClick={this.onClickMenu} selectedKeys={[activeMenuKey]} mode="vertical" items={userItems} />
        </div>
        <div className="user-right">
          <Switch>
            <Route path='/basic/user/order' component={OrderList} exact />
            <Route path='/basic/user/order/information/:id' component={OrderInformation} exact />
            <Route path='/basic/user/order/detail/:id/:report' component={OrderDetail} />
            <Route path='/basic/user/order/portQualityReport/:id' component={PortQualityReport} />
            <Route path='/basic/user/order/warehouseQualityReport/:order_id/:type/:quality_id' component={WarehouseQualityReport} />
            <Route path='/basic/user/order/CustomerQuality/:quality_id' component={CustomerQualityReport} />
            <Route path='/basic/user/proposalList/detail/:id' component={ProposalDetail} exact />
            <Route path='/basic/user/proposalList' component={ProposalList} exact />
            <Route path='/basic/user/proposalCart/purchasingList' component={ProposalPurchasingList} exact />
            <Route path='/basic/user/orderSettings' component={OrderSettings} exact />
            <Route path='/basic/user/returnOrder' component={returnOrder} exact />
            <Route path='/basic/user/proposalCart' component={ProposalCart} exact />
            <Route path='/basic/user/proposalCart/purchasingDetail' component={PurchasingDetail} exact />
            <Route path='/basic/user/proposal' component={Proposal} exact />
            <Route path='/basic/user/planOrder' component={PlanOrderList} exact />
            <Route path='/basic/user/planOrder/detail/:id' component={PlanOrderDetail} exact />
            <Route path='/basic/user/enquiryOrder' component={EnquiryOrderList} exact />
            <Route path='/basic/user/enquiryOrder/detail/:id' component={EnquiryOrderDetail} exact />
            <Route path='/basic/user/address' component={AddressList} />
            <Route path='/basic/user/erpList' component={ErpList} />
            <Route path='/basic/user/bill' component={Bill} exact />
            <Route path='/basic/user/bill/detail/:id' component={BillDetail} exact />
            <Route path='/basic/user/bill/print/:id' component={Print} exact />
            <Route path='/basic/user/annualPlanOrder' component={AnnualPlanOrderList} exact />
            <Route path='/basic/user/annualPlanOrder/detail' component={AnnualPlanOrderDetail} />
            <Route path='/basic/user/planReport' component={PlanList} exact />
            <Route path='/basic/user/planReport/reportedList' component={ReportedList} />
            <Route path='/basic/user/planReport/detail' component={PlanReportDetail} />
            <Route path='/basic/user/planReport/select/:taskNo/:supplierName/:supplierCode' component={SelectProducts} />
            <Route path='/basic/user/prePlanReport' component={PrePlanList} exact />
            <Route path='/basic/user/prePlanReport/reportedList' component={PreReportedList} />
            <Route path='/basic/user/prePlanReport/detail' component={PrePlanReportDetail} />
            <Route path='/basic/user/prePlanReport/select/:taskNo/:supplierName/:supplierCode' component={PreSelectProducts} />
            <Route path='/basic/user/qualityGradient' component={QualityGradient} exact />
            <Route path='/basic/user/qualityGradient/detail/:id?' component={QualityGradientDetail} exact />
            <Route path='/basic/user/qualityStandard' component={QualityStandard} exact />
            <Route path='/basic/user/qualityStandard/detail/:id?' component={QualityStandardDetail} exact />
            <Route path='/basic/user/qualityTask' component={QualityTask} exact />
            <Route path='/basic/user/qualityTask/detail/:id' component={QualityTaskDetail} exact />
            <Redirect to="/basic/user/order" />
          </Switch>
        </div>
      </div>
    );
  }
}

export default User;